export const MAIN_HEADER_HEIGHT = 72; // Default height of the main header in pixels
export const NOTIFICATION_BANNER_HEIGHT = 40; // Default height of the notification banner in pixels
